<template>
  <div>
    <gj-area-title>商品运营状态</gj-area-title>
    <div class="args-tags-list">
      <template v-for="tag in tags">
      <el-input
          :key="tag.id"
          class="input-edit-tag"
          v-if="tag.inputVisible"
          v-model="tag.name"
          size="small"
          @keyup.enter.native="editTagConfirm(tag)"
          @blur="editTagConfirm(tag)">
      </el-input>
      <el-tag
          v-else
          :key="tag.id"
          disable-transitions
          class="op-tag">
        {{tag.name}}
        <div v-if="tag.canDelete" class="op-icon-group">
<!--          <span @click="editTag(tag)"><gj-icon class="el-icon-edit op-icon"></gj-icon></span>-->
          <span v-if="tag.canDelete" @click="deleteTag(tag)">
            <gj-icon class="el-icon-circle-close op-icon"></gj-icon>
          </span>
        </div>
      </el-tag>
    </template>
    <el-input
        v-if="visible.addInput"
        ref="addInput"
        v-model="value.addInput"
        size="small"
        @keyup.enter.native="addTag"
        @blur="addTag"
        class="input-new-tag">
    </el-input>
    <el-button
        v-else
        class="button-new-tag"
        size="small"
        @click="showInput">
      + 添加
    </el-button>
    </div>
  </div>
</template>

<script>
  import {addListingSetting, deleteListingSetting, getListingSetting} from "../../../../../../../api/system";
  import {responseMixin} from "../../../../../../../minxins";
  import {isMeaningless} from "../../../../../../../utils/common";
  import {SALE_GET_OPERATION_STATE} from "../../../../../../../store/action-types";

  export default {
    name: "app-operation-state-args",
    mixins: [responseMixin],
    props: {
      tags: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        value: {
          addInput: null,
        },
        visible: {
          addInput: false
        }
      }
    },
    methods: {
      showInput() {
        this.visible.addInput = true;
        this.$nextTick(() => this.$refs.addInput.$refs.input.focus());
      },
      addTag() {
        if (isMeaningless(this.value.addInput)) {
          return;
        }
        addListingSetting({
          name: this.value.addInput,
          module: 'LISTING',
          type: 'OPERATION_STATE',
        })
          .then((res) => {
             this.$gjResponseHandle(res, () => {
               this.$gjMessage.success('添加成功');
               this.$emit('refresh');
               this.refreshStoreState();
             });
          })
          .complete(() => {
            this.value.addInput = null;
            this.visible.addInput = false;
          });
      },
      editTag(tag) {
        this.$set(tag, 'inputVisible', true);
      },
      editTagConfirm(tag) {
        this.$set(tag, 'inputVisible', false);
        // TODO: 更新
      },
      deleteTag(tag) {
        deleteListingSetting(tag.id)
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              const index = this.tags.findIndex(item => item.id === tag.id);
              if (index > -1) {
                this.tags.splice(index, 1);
              }
              this.$gjMessage.success('删除成功');
              this.$emit('refresh');
              this.refreshStoreState();
            });
          })
      },
      refreshStoreState() {
        this.$store.dispatch(SALE_GET_OPERATION_STATE);
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import 'common';
</style>


